"use client";

import { useMemo, useState } from "react";

import { ToolFrame } from "@/components/tools/ToolFrame";

export function SafetyStockEstimatorClient() {
  const [dailyDemand, setDailyDemand] = useState(14);
  const [leadTimeDays, setLeadTimeDays] = useState(12);
  const [demandStdDev, setDemandStdDev] = useState(6);
  const [serviceLevel, setServiceLevel] = useState(95);

  const z = serviceLevel >= 99 ? 2.33 : serviceLevel >= 97 ? 1.88 : serviceLevel >= 95 ? 1.65 : serviceLevel >= 90 ? 1.28 : 1.04;
  const safetyStock = useMemo(() => Math.max(0, Math.round(z * demandStdDev * Math.sqrt(Math.max(leadTimeDays, 0)))), [z, demandStdDev, leadTimeDays]);
  const reorderPoint = Math.max(0, Math.round(dailyDemand * leadTimeDays + safetyStock));

  return (
    <ToolFrame
      toolKey="safety-stock-estimator"
      title="Safety Stock Quick Estimator"
      embedPath="/embed/safety-stock-estimator"
      exportCsvRows={[{ dailyDemand, leadTimeDays, demandStdDev, serviceLevel, safetyStock, reorderPoint }]}
    >
      <div className="ed-card-glass" style={{ maxWidth: "520px", padding: "1rem", borderRadius: "12px", display: "grid", gap: ".65rem" }}>
        <Field label="Avg daily demand" value={dailyDemand} onChange={setDailyDemand} />
        <Field label="Lead time (days)" value={leadTimeDays} onChange={setLeadTimeDays} />
        <Field label="Demand variability (std dev)" value={demandStdDev} onChange={setDemandStdDev} />
        <Field label="Service level %" value={serviceLevel} onChange={setServiceLevel} />
        <div style={{ marginTop: ".35rem", borderTop: "1px solid rgba(148,163,184,.25)", paddingTop: ".7rem" }}>
          <p style={{ margin: "0 0 .2rem", color: "#64748b", fontSize: ".8rem" }}>Estimated safety stock</p>
          <p style={{ margin: 0, color: "#0c4a6e", fontSize: "1.5rem", fontWeight: 900 }}>{safetyStock} units</p>
          <p style={{ margin: ".4rem 0 0", color: "#334155", fontSize: ".9rem" }}>Suggested reorder point: {reorderPoint} units</p>
        </div>
      </div>
    </ToolFrame>
  );
}

function Field({ label, value, onChange }: { label: string; value: number; onChange: (v: number) => void }) {
  return (
    <label style={{ display: "grid", gap: ".3rem", fontSize: ".85rem", color: "#475569" }}>
      {label}
      <input
        type="number"
        value={value}
        onChange={(e) => onChange(Number(e.target.value || 0))}
        style={{ width: "100%", padding: ".55rem .65rem", borderRadius: "8px", border: "1px solid rgba(148,163,184,.45)", boxSizing: "border-box" }}
      />
    </label>
  );
}

